<template>
  <a-modal
    v-model:open="wordModalShow"
    centered
    destroyOnClose
    title="Word内容读取"
    width="400px"
    :footer="null"
    :bodyStyle="{ padding: '30px', height: '180px', overflow: 'hidden' }"
    :afterClose="hiddenModal"
  >
    <div>
      <a-button type="primary" @click="selectWord" :disabled="wordBtnDisabled">上传Word</a-button>
      <div style="margin-top: 10px; color: #f00">{{ wordResult }}</div>
      <div style="margin-top: 10px">
        注意事项：
        <br />
        1.当word中图片较多时，可用此功能上传到编辑器
        <br />
        2.只支持docx格式
      </div>
      <input
        v-show="false"
        type="file"
        @change="wordChange"
        ref="wordUploadRef"
        accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      />
    </div>
  </a-modal>
</template>

<script setup>
  import { ref, toRefs, watch } from 'vue'
  import { useGetters } from '@/utils/composables'

  const props = defineProps({
    show: {
      type: Boolean,
      default: false,
    },
  })
  const { show } = toRefs(props)
  watch(show, (val) => {
    if (val) {
      wordResult.value = ''
      wordModalShow.value = val
    }
  })

  const emit = defineEmits(['success', 'update:show'])
  const { api_url } = useGetters('settings', ['api_url'])

  const wordModalShow = ref(false) // word组件控制
  const wordUploadRef = ref(null)
  const wordResult = ref('')
  const wordBtnDisabled = ref(false)

  // 上传word
  const wordChange = (e) => {
    if (e.target.files.length == 0) return
    wordBtnDisabled.value = true
    let file = e.target.files[0]
    let f = new FormData()
    f.append('file', file)
    wordResult.value = '上传中...'
    let xhr = new XMLHttpRequest()
    const baseUrl = process.env.NODE_ENV === 'development' ? 'http://admin.dev.ehafo.com' : api_url.value
    xhr.open('POST', baseUrl + '/phalapi/public/?service=App.Common.wordToHtml', true)

    xhr.onloadend = function () {
      try {
        let ret = JSON.parse(xhr.responseText)
        if (ret.code == 0) {
          wordResult.value = ''
          var html_content = ret.data.html_content
          emit('success', html_content)
          wordModalShow.value = false
        } else {
          wordResult.value = ret.msg
        }
        wordBtnDisabled.value = false
      } catch (error) {
        wordResult.value = '上传失败，请重试'

        wordBtnDisabled.value = false
      }
    }
    xhr.send(f)
  }
  const selectWord = () => {
    wordUploadRef.value.click()
  }
  const hiddenModal = () => {
    emit('update:show', false)
  }
</script>

<style lang="scss" scoped></style>
